import { settings } from 'cc';
import { DEV } from 'cc/env';
import EnvironmentConfigType, { ConfigParamsMap, defaultConfigParamsMap } from '../../../../common/scripts/Config/EnvironmentConfigType';
import { Orientation } from '../../../../common/scripts/OrientationManager';
import { NumberFormatMode } from '../../../../common/scripts/Toolkit/Components/Label/NumberFormatter';
import DataType from '../../../../tableEngine/Script/Game/Data/Config/DataStructure';
import { TableSharedEnvironmentConfigType } from '../../../../tableEngine/Script/Game/Data/Config/TableEnvironmentConfig';
import ThemeConfig from './ThemeConfig';

export type LobbyEnvironmentConfigType = EnvironmentConfigType &
    TableSharedEnvironmentConfigType & {
        enableFreePlay: boolean;
        theme: ThemeConfig;
        allowKeyBoardDebug: boolean;
        hideDollar: boolean;
    };

export type LobbyConfigParamsMapType = { [config in keyof LobbyEnvironmentConfigType]: string } & ConfigParamsMap;

export const lobbyConfigParamsMap: LobbyConfigParamsMapType = {
    ...defaultConfigParamsMap,
    enableFreePlay: 'freePlay',
    theme: 'theme',
    hideDollar: 'dollar',
    allowKeyBoardDebug: 'allowKeyBoardDebug',
    hasTableList: 'hasTableList',
    supportedPlayType: 'supportedPlayType',
};

const environmentConfig: LobbyEnvironmentConfigType = {
    gameVersion: '0.0.14',
    gameDomain: DEV ? 'wss://api.lobby.dev.s7slot.online/api/v1/ws?encrypt=false' : settings.querySettings('settings', 'ServerHttp'),
    orientationConfig: {
        default: Orientation.Portrait,
        supportRotation: false,
    },
    theme: ThemeConfig.MSlot_Purple,
    hasTableList: true,
    supportedPlayType: [DataType.Enums.PlayType.Single, DataType.Enums.PlayType.Multiple, DataType.Enums.PlayType.Round],
    enableFreePlay: true,
    gameID: 'LOBBY',
    token: '',
    connectionTimeoutDuration: 0,
    isFakeToken: false,
    language: 'sch',
    homeURL: '',
    platformID: 1,
    walletType: 1,
    currency: 'USD',
    needEncrypt: DEV ? false : settings.querySettings('settings', 'Encrypt'),
    debug: DEV ? true : settings.querySettings('settings', 'Debug'),
    showFPS: DEV ? true : settings.querySettings('settings', 'Debug'),
    useIFrame: false,
    allowRotationOnPC: false,
    hideList: '',
    hideTxID: false,
    hideExit: false,
    hideZero: false,
    hideCurrency: false,
    hideDollar: false,
    debugKey: true,
    enableFullScreen: true,
    crm: false,
    crmBundleURL: '',
    supportCRM: false,
    numberFormatterMode: NumberFormatMode.CommaDot,
    bonusDomain: '',
    imageQuality: 0,
    allowKeyBoardDebug: true,
    hideVersion: false,
    compressErrorStack: false,
};

export default environmentConfig;
